import Image from 'next/image';
import { useState, useContext } from 'react';
import { useRouter } from 'next/navigation';
import { useWindowSize } from 'usehooks-ts';
import { XMarkIcon, Bars3Icon } from '@heroicons/react/24/solid';

import Button from '@components/button';
import AuthService from '@services/auth';
import UiUtils from '@utils/ui';
import { LOGO } from '@constants/ui';
import { GlobalContext } from '@context/global';

export default function NavBar() {
    const { setContextValues } = useContext(GlobalContext);

    const [menuOpen, setMenuOpen] = useState(false);

    const { width } = useWindowSize();
    const isMobile = UiUtils.isMobile(width);
    const isDesktop = !isMobile;

    const router = useRouter();
    
    const loggedIn = AuthService.isLoggedIn();

    function login() {
        router.push('/login');
    }

    function signUp() {
        router.push('/signup');
    }

    function gotoAdmin() {
        router.push('/admin');
    }

    function clearContext() {
        setContextValues([
            { key: "user", value: {} },
        ]);
    };

    function logOut() {
        clearContext();
        AuthService.logout()
        .then(response => {
            router.push('/');
        })
        .catch(error => console.log(error));
        return false;
    }

    function toggleMenu() {
        setMenuOpen(!menuOpen);
    }

    return (
        <>
            {isDesktop && (
                <div className="flex justify-between items-center box-border max-w-content-narrow w-full h-16 px-6 rounded-xl bg-white shadow-standard z-50 mx-auto">
                    <Image
                        src={LOGO.src}
                        height={26}
                        width={UiUtils.getLogoWidth(26)}
                        alt={LOGO.alt}
                    />
                    <div className="flex items-center justify-center gap-3">
                        {loggedIn && (
                            <>
                                <Button size="small" variant="outline" label="GO TO ADMIN SITE" onClick={gotoAdmin}/>
                                <Button size="small" variant="outline" label="LOG OUT" onClick={logOut}/>
                            </>
                        )}
                        {!loggedIn && (
                            <p className="font-vg-regular text-black text-lg">
                                You will need to login to access the Admin site
                            </p>
                        )}
                    </div>
                </div>
            )}
            {isMobile && (
                <div className="block box-border w-full rounded-xl bg-white shadow-standard z-50">
                    <div className="box-border w-full h-[50px] p-3 flex items-center justify-between">
                    <Image
                        src={LOGO.src}
                        height={25}
                        width={UiUtils.getLogoWidth(25)}
                        alt={LOGO.alt}
                    />
                    {menuOpen && (
                        <XMarkIcon 
                            className="h-6 text-black cursor-pointer" 
                            aria-label="Close nav menu"
                            onClick={toggleMenu}
                        />
                    )}
                    {!menuOpen && (
                        <Bars3Icon 
                            className="h-6 text-black cursor-pointer" 
                            aria-label="Open nav menu"
                            onClick={toggleMenu}
                        />
                    )}
                    </div>
                    <div className={menuOpen ? "box-border w-full px-4 pt-3 pb-6" : "hidden"}>
                        <div className="flex w-full mt-3 gap-3 justify-stretch">
                            {loggedIn && (
                                <>
                                    <Button size="small" variant="outline" label="GO TO ADMIN SITE" onClick={gotoAdmin}/>
                                    <Button size="small" variant="outline" label="LOG OUT" onClick={logOut}/>
                                </>
                            )}
                            {!loggedIn && (
                                <p className="font-vg-regular text-black text-lg">
                                    You will need to login to access the Admin site
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}